import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-candidate-score",
  templateUrl: "./candidate-score.component.html",
  styleUrls: ["./candidate-score.component.scss"],
})
export class CandidateScoreComponent implements OnInit {
  @Input("score") score: number | null;
  public emotion: string = "/assets/emotions/square/no-score.svg";
  public alt: string = "No score";

  constructor() {}

  ngOnInit() {
    if (this.score === null) {
      this.emotion = "/assets/emotions/square/no-score.svg";
      return;
    }
    if (this.score <= 100 && this.score >= 91) {
      this.emotion = "/assets/emotions/square/score-100-90.svg";
      this.alt = "Score between 90 and 100";
    } else if (this.score <= 90 && this.score >= 81) {
      this.emotion = "/assets/emotions/square/score-90-80.svg";
      this.alt = "Score between 80 and 90";
    } else if (this.score <= 80 && this.score >= 71) {
      this.emotion = "/assets/emotions/square/score-80-70.svg";
      this.alt = "Score between 70 and 80";
    } else if (this.score <= 70 && this.score >= 61) {
      this.emotion = "/assets/emotions/square/score-70-60.svg";
      this.alt = "Score between 60 and 70";
    } else if (this.score <= 60 && this.score >= 51) {
      this.emotion = "/assets/emotions/square/score-60-50.svg";
      this.alt = "Score between 50 and 60";
    } else if (this.score <= 50 && this.score >= 26) {
      this.emotion = "/assets/emotions/square/score-50-25.svg";
      this.alt = "Score between 25 and 50";
    } else if (this.score <= 25 && this.score >= 0) {
      this.emotion = "/assets/emotions/square/score-25-0.svg";
      this.alt = "Score between 25 and 1";
    }
  }
}
